/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Link_Distance_Service_ContractInputs */

const tr_legal_footer_link_distance_service_contract = /** @type {(inputs: Legal_Footer_Link_Distance_Service_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Hizmet Sözleşmesi`)
};

const en_legal_footer_link_distance_service_contract = /** @type {(inputs: Legal_Footer_Link_Distance_Service_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance Service Agreement`)
};

const de_legal_footer_link_distance_service_contract = /** @type {(inputs: Legal_Footer_Link_Distance_Service_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fernabsatzvertrag für Dienstleistungen`)
};

const ru_legal_footer_link_distance_service_contract = /** @type {(inputs: Legal_Footer_Link_Distance_Service_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дистанционный договор оказания услуг`)
};

/**
* | output |
* | --- |
* | "Distance Service Agreement" |
*
* @param {Legal_Footer_Link_Distance_Service_ContractInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_link_distance_service_contract = /** @type {((inputs?: Legal_Footer_Link_Distance_Service_ContractInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Link_Distance_Service_ContractInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_link_distance_service_contract(inputs)
	if (locale === "de") return de_legal_footer_link_distance_service_contract(inputs)
	if (locale === "ru") return ru_legal_footer_link_distance_service_contract(inputs)
	return tr_legal_footer_link_distance_service_contract(inputs)
});